import script from "./OfficialWebsite.vue?vue&type=script&setup=true&lang=js"
export * from "./OfficialWebsite.vue?vue&type=script&setup=true&lang=js"

import "./OfficialWebsite.vue?vue&type=style&index=0&id=547aaafa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547aaafa"]])

export default __exports__